import CONFIG from "../appconfig.json";
import axios from "axios";
import { GetAuthorisationHeaderGroup, GetBearerToken } from "./assetxphelpers";
import offlineConfig from "../config/offlineMode";
import mockDataProvider from "../store/mock/mockDataProvider";
import { workspaceService } from "../services/workspaceService";
import { downloadBlob, MIME_TYPES } from "../services/fileDownload";

let getMyMarketsInFlight = null;
let lastFetchedTenantId = null;

export const assetxpstate = {
  namespaced: true,
  state: {
    searchResults: {
      results: [],
      token: "",
      hasNextPage: false,
    },
    inventorySearchResults: {
      results: [],
      token: "",
      hasNextPage: false,
    },
    searchInProgress: true,
    catalogueCachedData: [],
    sectionHeaders: null,
    categoryHeaders: null,
    downloadingResources: false,
    section: null,
    asset: null,
    assetList: null,
    searchData: {},
    prevSearchedSection: "",
    navDrawIsOpen: true,
    uploadPercentageComplete: null,
    inventoryActive: false,
    inventoryAssetList: {
      id: "",
      name: "Test List",
      specificAssets: [],
    },
    savedSectionSearches: [],
    teams: [],
    markets: [],
    marketsTenantId: null,
    selectedMarketId: sessionStorage.getItem("selectedMarketId") || null,
    selectedMarketSource: null,
    selectedMarketChangedAtMs: 0,
    selectedMarketUserChangedAtMs: 0,
    clonableSectionIds: [],
    profiles: [],
    assetProfileData: [],
    assetProfileDataAssetId: null,
  },
  mutations: {
    SetTeams(state, teams) {
      state.teams = teams;
    },
    SetMarkets(state, markets) {
      state.markets = markets || [];
    },
    SetMarketsTenantId(state, tenantId) {
      state.marketsTenantId = tenantId || null;
    },
    SetSelectedMarket(state, payload) {
      const hasPayloadObject = payload && typeof payload === "object" && !Array.isArray(payload);
      const marketId = hasPayloadObject ? payload.marketId || null : payload;
      const source = hasPayloadObject ? payload.source || "unknown" : "unknown";

      state.selectedMarketId = marketId;
      state.selectedMarketSource = source;
      state.selectedMarketChangedAtMs = Date.now();
      if (source === "user-select") {
        state.selectedMarketUserChangedAtMs = state.selectedMarketChangedAtMs;
      }
      if (marketId) {
        sessionStorage.setItem("selectedMarketId", marketId);
      } else {
        sessionStorage.removeItem("selectedMarketId");
      }
    },
    SetClonableSectionIds(state, clonableSectionIds) {
      state.clonableSectionIds = clonableSectionIds || [];
    },
    UpsertCachedSectionSearch(state, sectionSearchData) {
      //If it already exists in the array, remove it
      for (let i = 0; i < state.savedSectionSearches.length; i++) {
        const element = state.savedSectionSearches[i];
        if (element.id == sectionSearchData.id) {
          state.savedSectionSearches.splice(i, 1);
        }
      }

      state.savedSectionSearches.push(sectionSearchData);
    },
    ClearSectionSearchFromCache(state, sectionid) {
      for (let i = 0; i < state.savedSectionSearches.length; i++) {
        const element = state.savedSectionSearches[i];
        if (element.id == sectionid) {
          state.savedSectionSearches.splice(i, 1);
        }
      }
    },
    ClearAllSectionSearchFromCache(state) {
      state.savedSectionSearches = [];
    },
    ChangeCurrentInventoryListName(state, newName) {
      state.inventoryAssetList.name = newName;
    },
    ChangeCurrentAssetListTeams(state, newTeams) {
      state.assetList.teams = newTeams;
    },
    ChangeCurrentAssetListName(state, newName) {
      state.assetList.name = newName;
    },
    SetCurrentAssetList(state, assetList) {
      state.assetList = assetList;
    },
    AddAssetsToCurrentAssetList(state, assetidsToAdd) {
      for (let i = 0; i < assetidsToAdd.length; i++) {
        if (
          state.inventoryAssetList.specificAssets.indexOf(assetidsToAdd[i]) ===
          -1
        ) {
          state.inventoryAssetList.specificAssets.push(assetidsToAdd[i]);
        }
      }
    },
    RemoveAssetFromCurrentAssetList(state, assetidToRemove) {
      var index = state.assetList.specificAssets.indexOf(assetidToRemove);

      if (index > -1) {
        state.assetList.specificAssets.splice(index, 1);
      }
    },
    RemoveAssetFromInventoryAssetList(state, assetidToRemove) {
      var index = state.inventoryAssetList.specificAssets.indexOf(
        assetidToRemove
      );

      if (index > -1) {
        state.inventoryAssetList.specificAssets.splice(index, 1);
      }

      for (let i = 0; i < state.inventorySearchResults.results.length; i++) {
        const element = state.inventorySearchResults.results[i];

        if (element.id == assetidToRemove) {
          state.inventorySearchResults.results.splice(i, 1);
          break;
        }
      }
    },
    SetInventoryActiveState(state, isInventoryActive) {
      state.inventoryActive = isInventoryActive;
    },
    LoadInventoryAssetList(state, inventoryAssetList) {
      if (!state.inventoryActive) state.inventoryActive = true;

      state.inventoryAssetList = inventoryAssetList;
    },
    SetCachedCatalogueData(state, newDataPayload) {
      var foundExistingData = false;
      for (let i = 0; i < state.catalogueCachedData.length; i++) {
        if (state.catalogueCachedData[i].section == newDataPayload.section) {
          state.catalogueCachedData[i] = newDataPayload;
          foundExistingData = true;
          break;
        }
      }

      if (!foundExistingData) {
        state.catalogueCachedData.push(newDataPayload);
      }
    },
    SetDrawerState(state, isOpen) {
      state.navDrawIsOpen = isOpen;
    },
    SetSearchedSection(state, sectionName) {
      state.prevSearchedSection = sectionName;
    },
    SetSearchInProgress(state, isSearching) {
      state.searchInProgress = isSearching;
    },
    ClearSearch(state) {
      state.searchResults.results = [];
      state.searchResults.token = "";
      state.searchResults.hasNextPage = false;
    },
    ClearInventorySearch(state) {
      state.inventorySearchResults.results = [];
      state.inventorySearchResults.token = "";
      state.inventorySearchResults.hasNextPage = false;
    },
    SetSearchResults(state, searchResults) {
      state.searchResults.results = state.searchResults.results.concat(
        searchResults.results
      );
      state.searchResults.token = searchResults.token;
      state.searchResults.hasNextPage = searchResults.hasNextPage;
    },
    SetInventorySearchResults(state, searchResults) {
      state.inventorySearchResults.results = state.inventorySearchResults.results.concat(
        searchResults.results
      );
      state.inventorySearchResults.token = searchResults.token;
      state.inventorySearchResults.hasNextPage = searchResults.hasNextPage;
    },
    SetSectionHeaders(state, sectionHeaders) {
      state.sectionHeaders = sectionHeaders;
    },
    SetCategoryHeaders(state, categoryHeaders) {
      state.categoryHeaders = categoryHeaders;
    },
    SetActiveSection(state, section) {
      state.section = section;
    },
    SetActiveAsset(state, asset) {
      state.asset = asset;
    },
    SetProfiles(state, profiles) {
      state.profiles = Array.isArray(profiles) ? profiles : [];
    },
    SetAssetProfileData(state, assetProfileData) {
      state.assetProfileData = Array.isArray(assetProfileData)
        ? assetProfileData
        : [];
    },
    SetAssetProfileDataAssetId(state, assetId) {
      state.assetProfileDataAssetId = assetId || null;
    },
    UpsertAssetProfileDataRecord(state, assetProfileDataRecord) {
      if (!assetProfileDataRecord) {
        return;
      }

      const existingIndex = state.assetProfileData.findIndex(
        (item) =>
          item.id === assetProfileDataRecord.id ||
          item.profileId === assetProfileDataRecord.profileId
      );

      if (existingIndex === -1) {
        state.assetProfileData.push(assetProfileDataRecord);
        return;
      }

      state.assetProfileData.splice(existingIndex, 1, assetProfileDataRecord);
    },
    AddProfileIdentifier(state, payload) {
      // payload: { profileId, identifier: { value, normalized } }
      const profileData = state.assetProfileData.find(p => p.profileId === payload.profileId);
      if (profileData) {
        // Check if identifier already exists (by normalized value)
        const exists = profileData.identifiers?.some(id => id.normalized === payload.identifier.normalized);
        if (!exists) {
          if (!profileData.identifiers) {
            profileData.identifiers = [];
          }
          profileData.identifiers.push(payload.identifier);
        }
      }
    },
    RemoveProfileIdentifier(state, payload) {
      // payload: { profileId, normalizedValue }
      const profileData = state.assetProfileData.find(p => p.profileId === payload.profileId);
      if (profileData && profileData.identifiers) {
        const index = profileData.identifiers.findIndex(id => id.normalized === payload.normalizedValue);
        if (index > -1) {
          profileData.identifiers.splice(index, 1);
        }
        // If no identifiers left, remove the profile record entirely
        if (profileData.identifiers.length === 0) {
          const recordIndex = state.assetProfileData.findIndex(p => p.id === profileData.id);
          if (recordIndex > -1) {
            state.assetProfileData.splice(recordIndex, 1);
          }
        }
      }
    },
    SetDownloadingResources(state) {
      state.downloadingResources = !state.downloadingResources;
    },
    SetSearchData(state, searchData) {
      state.searchData = searchData;
    },
    AttributeAdded(state, attribute) {
      var current = state.asset.attributes.filter((e) => e.id == attribute.id);

      if (current.length == 0) state.asset.attributes.push(attribute);
    },
    AttributeRemoved(state, attribute) {
      for (let i = 0; i < state.asset.attributes.length; i++) {
        if (state.asset.attributes[i].id == attribute.id) {
          state.asset.attributes.splice(i, 1);
          break;
        }
      }
    },
    AttributeUpdated(state, attribute) {
      for (let i = 0; i < state.asset.attributes.length; i++) {
        if (state.asset.attributes[i].id == attribute.id) {
          state.asset.attributes.splice(i, 1, attribute);
          break;
        }
      }
    },
    SetUploadPercentageComplete(state, percentage) {
      state.uploadPercentageComplete = percentage;
    },
  },
  /* eslint-disable no-unused-vars */
  actions: {
    async selectMarket({ commit, dispatch, rootState }, marketId) {
      const tenantId =
        rootState.workspace?.currentTenantId ||
        rootState.authentication.user?.profile?.selected_tenant ||
        null;
      const previousSelectedMarketId =
        rootState.assetxpstate?.selectedMarketId || null;
      console.log("[MarketTrace][selectMarket] request", {
        tenantId,
        incomingMarketId: marketId || null,
        previousSelectedMarketId,
      });

      commit("SetSelectedMarket", { marketId, source: "user-select" });
      if (marketId && tenantId) {
        try {
          sessionStorage.setItem(
            "assetxp_local_market_change",
            JSON.stringify({
              tenantId: String(tenantId),
              marketId: String(marketId),
              atMs: Date.now(),
            })
          );
        } catch (e) {
          // Ignore storage issues; this marker is best-effort for modal suppression.
        }
      }
      // Update authentication permissions for the new market
      dispatch("authentication/updateMarketPermissions", null, { root: true });

      // Broadcast user-initiated market change immediately so other apps/tabs converge
      // without waiting for polling drift reconciliation.
      if (marketId && previousSelectedMarketId !== marketId) {
        try {
          if (typeof BroadcastChannel !== "undefined") {
            const ch = new BroadcastChannel("ixp-workspace-channel");
            ch.postMessage({
              type: "market-switched",
              tenantId,
              marketId,
              timestamp: Date.now(),
            });
            ch.close();
          }
        } catch (err) {
          console.warn("[selectMarket] BroadcastChannel market notification failed:", err);
        }

        try {
          if (typeof window !== "undefined" && window.localStorage) {
            localStorage.setItem(
              "ixp-market-switched",
              JSON.stringify({
                type: "market-switched",
                tenantId,
                marketId,
                timestamp: Date.now(),
              })
            );
            setTimeout(() => {
              try {
                localStorage.removeItem("ixp-market-switched");
              } catch (e) {
                // Ignore cleanup errors.
              }
            }, 1000);
          }
        } catch (err) {
          console.warn("[selectMarket] localStorage market notification failed:", err);
        }
      }

      // Persist to DB so other apps (e.g. Online Portal) pick up the change via /ping drift detection.
      if (marketId) {
        try {
          const token = await workspaceService.getResolvedAccessToken();
          if (!token) {
            console.warn("[selectMarket] No resolved access token for setmarket persist", {
              tenantId,
              marketId,
            });
          } else {
            const response = await fetch(
              CONFIG.platformEndpoints.authentication.replace(/\/$/, "") + "/api/workspace/setmarket",
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + token,
                },
                body: JSON.stringify({ marketId }),
              }
            );

            if (!response.ok) {
              const text = await response.text().catch(() => "");
              console.warn("[selectMarket] setmarket persist failed", {
                tenantId,
                marketId,
                status: response.status,
                body: text.slice(0, 200),
              });
            } else {
              console.log("[MarketTrace][selectMarket] setmarket persisted", {
                tenantId,
                marketId,
                status: response.status,
              });
            }
          }
        } catch (err) {
          console.warn("[selectMarket] setmarket persist failed:", err);
        }
      }

      console.log("[MarketTrace][selectMarket] applied", {
        tenantId,
        selectedMarketId: rootState.assetxpstate?.selectedMarketId || null,
      });
    },
    DownloadPDFForAssetList({ commit }, assetListid) {
      return new Promise((resolve) => {
        axios({
          url:
            CONFIG.platformEndpoints.assetxpapi +
            "section/getpdfforassetlist/" +
            assetListid,
          method: "GET",
          responseType: "blob",
          headers: { Authorization: GetBearerToken() },
          config: { headers: { Authorization: GetBearerToken() } },
        }).then((response) => {
          const blob = new Blob([response.data], { type: MIME_TYPES.pdf });
          downloadBlob(blob, "AssetExport.pdf");
          resolve();
        });
      });
    },
    DownloadPDFMultiple({ commit }, assetListings) {
      return new Promise((resolve) => {
        axios({
          url:
            CONFIG.platformEndpoints.assetxpapi + "section/downloadpdfmultiple",
          method: "POST",
          data: assetListings,
          responseType: "blob",
          headers: { Authorization: GetBearerToken() },
          config: { headers: { Authorization: GetBearerToken() } },
        }).then((response) => {
          const blob = new Blob([response.data], { type: MIME_TYPES.pdf });
          downloadBlob(blob, "AssetExport.pdf");
          resolve();
        });
      });
    },
    StartInternalImageCopyManifestJob({ getters }, payload) {
      return new Promise((resolve, reject) => {
        const marketId = getters.effectiveMarketId;
        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi +
              "asset/internal-copy-images-manifest",
            {
              sectionId: payload.sectionId,
              categoryId: payload.categoryId,
              categoryName: payload.categoryName,
              marketId,
            },
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    GetInternalImageCopyManifestJobStatus({ commit }, jobId) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            CONFIG.platformEndpoints.assetxpapi +
              `asset/getinternalimagecopyjobstatus/${jobId}`,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    DownloadInternalImageCopyManifest({ commit }, jobId) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            CONFIG.platformEndpoints.assetxpapi +
            `asset/downloadinternalimagecopymanifest/${jobId}`,
          method: "GET",
          responseType: "blob",
          headers: { Authorization: GetBearerToken() },
        })
          .then((response) => {
            const contentDisposition =
              response?.headers?.["content-disposition"] || "";
            const fileNameMatch = contentDisposition.match(
              /filename\*?=(?:UTF-8''|")?([^";]+)/i
            );
            const resolvedFileName = fileNameMatch
              ? decodeURIComponent(fileNameMatch[1].replace(/"/g, "").trim())
              : "manifest.json";
            const blob = new Blob([response.data], {
              type: MIME_TYPES.json,
            });
            downloadBlob(blob, resolvedFileName);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    DownloadPDF({ commit }, assetDetailid) {
      return new Promise((resolve) => {
        axios({
          url:
            CONFIG.platformEndpoints.assetxpapi +
            "asset/downloadpdf/" +
            assetDetailid,
          method: "GET",
          responseType: "blob",
          headers: { Authorization: GetBearerToken() },
          config: { headers: { Authorization: GetBearerToken() } },
        }).then((response) => {
          const blob = new Blob([response.data], { type: MIME_TYPES.pdf });
          downloadBlob(blob, "AssetExport.pdf");
          resolve();
        });
      });
    },
    GetMarkets({ commit }) {
      return new Promise((resolve) => {
        axios
          .get(CONFIG.platformEndpoints.authentication + "open/GetMarkets")
          .then((response) => {
            console.log("Got markets", response.data);
            resolve(response.data);
          })
          .catch((error) => {
            resolve([]);
          });
      });
    },
    GetTeams({ commit }) {
      return new Promise((resolve) => {
        axios
          .get(CONFIG.platformEndpoints.authentication + "open/GetTeams")
          .then((response) => {
            commit("SetTeams", response.data);
            resolve(response.data);
          })
          .catch((error) => {
            resolve([]);
          });
      });
    },
    GetMyMarkets({ commit, rootState, dispatch, state }) {
      // Invalidate cache if tenant changed (switching workspaces must always re-fetch markets)
      const currentTenantId =
        rootState.workspace?.currentTenantId ||
        rootState.authentication.user?.profile?.selected_tenant ||
        null;
      const tokenSelectedMarket =
        rootState.authentication.user?.profile?.selected_market || null;
      const tokenDefaultMarket =
        rootState.authentication.user?.profile?.["ixp_markets.defaultmarket"] || null;

      if (currentTenantId !== lastFetchedTenantId) {
        console.log("[MarketTrace][GetMyMarkets] tenant changed, invalidating in-flight", {
          previousTenantId: lastFetchedTenantId,
          currentTenantId,
        });
        getMyMarketsInFlight = null;
        lastFetchedTenantId = currentTenantId;
      }

      if (getMyMarketsInFlight) {
        console.log("[MarketTrace][GetMyMarkets] returning in-flight promise", {
          currentTenantId,
          selectedMarketId: rootState.assetxpstate.selectedMarketId || null,
        });
        return getMyMarketsInFlight;
      }

      getMyMarketsInFlight = new Promise((resolve) => {
        console.log("[MarketTrace][GetMyMarkets] start", {
          selected_tenant: rootState.authentication.user?.profile?.selected_tenant || null,
          currentTenantId,
          selectedMarketId: rootState.assetxpstate.selectedMarketId || null,
          tokenSelectedMarket,
          tokenDefaultMarket,
          marketsTenantId: rootState.assetxpstate.marketsTenantId || null,
          marketAccess:
            rootState.authentication.user?.profile?.["ixp_markets.access"],
        });

        // Authoritative path: tenant-scoped market resolution on server.
        // Avoid claim-derived market lookups here; they can be stale during cross-app token transitions.
        const myAccessibleMarketsUrl =
          CONFIG.platformEndpoints.authentication +
          "api/markets/myaccessiblemarkets";

        const fetchMyAccessibleMarkets = async () => {
          const resolvedToken = await workspaceService.getResolvedAccessToken();
          const authHeader = resolvedToken
            ? { headers: { Authorization: "Bearer " + resolvedToken } }
            : GetAuthorisationHeaderGroup();

          return axios.get(myAccessibleMarketsUrl, authHeader);
        };

        const resolveMarketsOnce = async () => {
          const primaryResponse = await fetchMyAccessibleMarkets();
          return primaryResponse.data || [];
        };

        resolveMarketsOnce()
          .then(async (initialMarkets) => {
            let markets = initialMarkets || [];

            // If API temporarily returns empty during token propagation, refresh auth and retry once.
            if (
              Array.isArray(markets) &&
              markets.length === 0
            ) {
              try {
                await dispatch("authentication/updateLoggedInStatus", null, {
                  root: true,
                });
                markets = await resolveMarketsOnce();
              } catch (retryErr) {
                console.warn("[GetMyMarkets] retry after auth refresh failed:", retryErr);
              }
            }

            const currentTenantId =
              rootState.workspace?.currentTenantId ||
              rootState.authentication.user?.profile?.selected_tenant ||
              null;

            const beforeSelectedMarketId = rootState.assetxpstate.selectedMarketId || null;
            const marketIds = markets
              .filter((m) => m && m.id)
              .map((m) => m.id);

            console.log("[MarketTrace][GetMyMarkets] before commit", {
              currentTenantId,
              beforeSelectedMarketId,
              marketCount: marketIds.length,
              marketIds,
            });

            commit("SetMarkets", markets);
            commit("SetMarketsTenantId", currentTenantId);

            // If persisted market selection is not valid for this workspace, clear it.
            const selectedMarketId = rootState.assetxpstate.selectedMarketId;
            if (
              selectedMarketId &&
              !markets.some((m) => m && m.id === selectedMarketId)
            ) {
              console.log("[GetMyMarkets] Clearing stale selectedMarketId:", selectedMarketId);
              commit("SetSelectedMarket", null);
            }

            console.log("[MarketTrace][GetMyMarkets] resolved", {
              selected_tenant: rootState.authentication.user?.profile?.selected_tenant || null,
              currentTenantId,
              selectedMarketId: rootState.assetxpstate.selectedMarketId || null,
              tokenSelectedMarket:
                rootState.authentication.user?.profile?.selected_market || null,
              tokenDefaultMarket:
                rootState.authentication.user?.profile?.["ixp_markets.defaultmarket"] || null,
              marketsTenantId: rootState.assetxpstate.marketsTenantId || null,
              markets: markets.map((m) => m && m.id),
            });

            getMyMarketsInFlight = null;
            resolve(markets);
          })
          .catch(async () => {
            console.warn("[MarketTrace][GetMyMarkets] request failed, entering fallback", {
              currentTenantId,
              selectedMarketId: rootState.assetxpstate.selectedMarketId || null,
            });
            // Only fallback to mock data if offline mode explicitly enabled
            if (offlineConfig.isOfflineMode && offlineConfig.useMockData) {
              try {
                const mock = await mockDataProvider.getMockData(
                  myAccessibleMarketsUrl,
                  "get"
                );
                if (mock !== null) {
                  const currentTenantId =
                    rootState.workspace?.currentTenantId ||
                    rootState.authentication.user?.profile?.selected_tenant ||
                    null;
                  commit("SetMarkets", mock);
                  commit("SetMarketsTenantId", currentTenantId);
                  console.log("[MarketTrace][GetMyMarkets] mock resolved", {
                    currentTenantId,
                    selectedMarketId: rootState.assetxpstate.selectedMarketId || null,
                    marketCount: Array.isArray(mock) ? mock.length : 0,
                  });
                  getMyMarketsInFlight = null;
                  resolve(mock);
                  return;
                }
              } catch (e) {
                // ignore and fall through
              }
            }
            const currentTenantId =
              rootState.workspace?.currentTenantId ||
              rootState.authentication.user?.profile?.selected_tenant ||
              null;

            commit("SetMarkets", []);
            commit("SetMarketsTenantId", currentTenantId);
            commit("SetSelectedMarket", null);
            console.warn("[MarketTrace][GetMyMarkets] resolved empty fallback", {
              currentTenantId,
              selectedMarketId: null,
            });
            getMyMarketsInFlight = null;
            resolve([]);
          });
      });

      return getMyMarketsInFlight;
    },
    GetClonableSectionIds({ commit }) {
      return new Promise((resolve) => {
        axios
          .get(
            CONFIG.platformEndpoints.assetxpapi +
              "api/ClonableAssets/get-clonable-section-ids",
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            commit("SetClonableSectionIds", response.data);
            resolve(response.data);
          })
          .catch((error) => {
            console.error("Error fetching clonable section IDs:", error);
            resolve([]);
          });
      });
    },
    SetSectionFocusedAttributes({ commit, state }, focusedAttributes) {
      commit("SetCurrentAssetList", null);
      return new Promise((resolve) => {
        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi +
              "section/setfocusedattributes/" +
              state.section.id,
            focusedAttributes,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve();
          });
      });
    },
    SetAssetList({ commit }, assetListid) {
      commit("SetCurrentAssetList", null);
      return new Promise((resolve) => {
        axios
          .get(
            CONFIG.platformEndpoints.assetxpapi +
              "section/getassetlist/" +
              assetListid,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            commit("SetCurrentAssetList", response.data);
            resolve();
          });
      });
    },
    DeleteCurrentAssetList({ commit, state }) {
      return new Promise((resolve) => {
        axios
          .get(
            CONFIG.platformEndpoints.assetxpapi +
              "section/removeassetlist/" +
              state.assetList.id,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            commit("SetCurrentAssetList", null);
            resolve();
          });
      });
    },
    SearchWithAssetList({ commit }, searchParams) {
      return new Promise((resolve) => {
        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi + "asset/searchWithAssetList",
            searchParams,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            if (searchParams.commit)
              commit("SetInventorySearchResults", response.data);
            resolve(response.data);
          });
      });
    },
    SearchForAssetList({ commit }, searchParams) {
      return new Promise((resolve) => {
        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi + "asset/searchWithAssetList",
            searchParams,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve();
          });
      });
    },
    SearchAssetLists({ commit }, searchParams) {
      searchParams.withTeams = false;
      return new Promise((resolve) => {
        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi + "section/SearchAssetLists",
            searchParams,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve(response.data);
          });
      });
    },
    UpsertAssetList({ commit, state }, assetList) {
      return new Promise((resolve) => {
        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi + "section/upsertassetlist",
            assetList,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve(response.data);
          });
      });
    },
    UpdateADContent({ commit }, updateObj) {
      return new Promise((resolve) => {
        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi + "asset/updateadcontent",
            updateObj,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            commit("AttributeRemoved", updateObj);
            resolve();
          });
      });
    },
    RemoveAttributeFromAsset({ commit }, updateObj) {
      return new Promise((resolve) => {
        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi +
              "asset/removeattribute/" +
              updateObj.assetListingid,
            updateObj,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            commit("AttributeRemoved", updateObj);
            resolve();
          });
      });
    },
    AddAttributeToAsset({ commit }, updateObj) {
      return new Promise((resolve) => {
        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi +
              "asset/addattribute/" +
              updateObj.assetListingid,
            updateObj,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            commit("AttributeAdded", response.data);
            resolve();
          });
      });
    },
    UpdateAssetAttributeAsset({ commit, getters }, updateObj) {
      return new Promise((resolve) => {
        const marketId = getters.effectiveMarketId;
        const marketQuery = marketId
          ? `?marketId=${encodeURIComponent(marketId)}`
          : "";
        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi +
              "assetcontext/updateattributeasset/" +
              updateObj.assetListingid +
              marketQuery,
            updateObj,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            var atb = response.data.attributes.filter(
              (e) => e.id == updateObj.id
            );
            if (atb.length > 0) {
              commit("AttributeUpdated", atb[0]);
            }

            resolve();
          });
      });
    },
    UpdateAssetAttributeMulti({ commit }, updateObj) {
      return new Promise((resolve) => {
        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi +
              "asset/updateattributemulti/" +
              updateObj.assetListingid,
            updateObj,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            var atb = response.data.attributes.filter(
              (e) => e.id == updateObj.id
            );
            if (atb.length > 0) {
              commit("AttributeUpdated", atb[0]);
            }

            resolve(response.data);
          });
      });
    },
    UpdateAssetAttribute({ commit, getters }, updateObj) {
      return new Promise((resolve) => {
        const marketId = getters.effectiveMarketId;
        const marketQuery = marketId
          ? `?marketId=${encodeURIComponent(marketId)}`
          : "";
        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi +
              "assetcontext/updateattribute/" +
              updateObj.assetListingid +
              marketQuery,
            updateObj,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            var atb = response.data.attributes.filter(
              (e) => e.id == updateObj.id
            );
            if (atb.length > 0) {
              commit("AttributeUpdated", atb[0]);
            }

            resolve(response.data);
          });
      });
    },

    GetJob({ commit }, alJobId) {
      return new Promise((resolve) => {
        axios
          .get(
            CONFIG.platformEndpoints.assetxpapi + "aljob/get/" + alJobId,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve(response);
          });
      });
    },
    StartNewJob({ commit }, jobDetails) {
      return new Promise((resolve) => {
        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi + "alJob/create/",
            jobDetails,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve(response);
          });
      });
    },

    GetImportJobStatus({ commit }, jobId) {
      return new Promise((resolve) => {
        axios
          .get(
            CONFIG.platformEndpoints.assetxpapi +
              "asset/getassetimportjobstatus/" +
              jobId,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve(response);
          });
      });
    },
    ImportAssetsFromFile({ commit, getters }, payload) {
      return new Promise((resolve, reject) => {
        const formData = payload && payload.formData ? payload.formData : payload;
        const dryRun = payload && payload.dryRun === true;
        const marketId = getters.effectiveMarketId;
        const baseEndpoint = marketId
          ? `asset/importassetsfromfile/${marketId}`
          : "asset/importassetsfromfile/";
        const endpoint = `${baseEndpoint}?dryRun=${dryRun}`;

        axios({
          method: "post",
          data: formData,
          url: CONFIG.platformEndpoints.assetxpapi + endpoint,
          headers: {
            Authorization: GetBearerToken(),
          },
          onUploadProgress: function(progressEvent) {
            commit(
              "SetUploadPercentageComplete",
              Math.round(progressEvent.loaded * 100) / progressEvent.total
            );
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    CommitDryRunImport({ getters }, dryRunJobId) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi + `asset/commitdryrunimport/${dryRunJobId}`,
            null,
            {
              headers: {
                Authorization: GetBearerToken(),
              },
            }
          )
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    DownloadDryRunReport({ getters }, jobId) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: CONFIG.platformEndpoints.assetxpapi + `asset/downloaddryrunreport/${jobId}`,
          responseType: "blob",
          headers: {
            Authorization: GetBearerToken(),
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    GetAssetImportTemplate({ commit, getters }) {
      return new Promise((resolve) => {
        const marketId = getters.effectiveMarketId;
        const endpoint = marketId
          ? `asset/getassetimporttemplate/${marketId}`
          : "asset/getassetimporttemplate/";

        axios({
          url: CONFIG.platformEndpoints.assetxpapi + endpoint,
          method: "GET",
          responseType: "blob",
          headers: { Authorization: GetBearerToken() },
          config: { headers: { Authorization: GetBearerToken() } },
        }).then((response) => {
          const blob = new Blob([response.data], { type: MIME_TYPES.xlsx });
          downloadBlob(blob, "ImportTemplate.xlsx");
          resolve();
        });
      });
    },

    //Search
    GetSearchData({ commit, getters }, sectionid) {
      return new Promise((resolve, reject) => {
        const marketId = getters.effectiveMarketId;
        const endpoint = marketId
          ? `section/getsearchdata/${sectionid}/${marketId}`
          : `section/getsearchdata/${sectionid}`;

        axios
          .get(
            CONFIG.platformEndpoints.assetxpapi + endpoint,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            commit("SetSearchData", response.data);
            resolve();
          })
          .catch(reject);
      });
    },
    GetSearchResults({ commit, getters, rootGetters, rootState }, searchParams) {
      commit("SetSearchedSection", searchParams.sectionName);
      commit("SetSearchInProgress", true);
      return new Promise((resolve) => {
        const requestTenantId =
          rootState.authentication.user?.profile?.selected_tenant ||
          rootState.workspace?.currentTenantId ||
          null;

        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi + "asset/search",
            searchParams,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            const activeTenantId =
              rootState.authentication.user?.profile?.selected_tenant ||
              rootState.workspace?.currentTenantId ||
              null;

            if (String(activeTenantId || "") !== String(requestTenantId || "")) {
              console.warn("[GetSearchResults] dropping stale cross-tenant response", {
                requestTenantId,
                activeTenantId,
              });
              commit("SetSearchInProgress", false);
              resolve();
              return;
            }

            const hasMarketAccess = rootGetters["authentication/hasMarketAccess"];
            const effectiveMarketId = getters.effectiveMarketId;
            const payload = response && response.data ? response.data : {};
            const sourceResults = Array.isArray(payload.results)
              ? payload.results
              : [];

            // Final UI guard: only show results from resolved market when user is market-scoped.
            const filteredResults =
              hasMarketAccess && effectiveMarketId
                ? sourceResults.filter((r) => {
                    if (!r || !r.marketId) return true;
                    return (
                      String(r.marketId).toLowerCase() ===
                      String(effectiveMarketId).toLowerCase()
                    );
                  })
                : sourceResults;

            commit("SetSearchInProgress", false);
            commit("SetSearchResults", {
              ...payload,
              results: filteredResults,
            });
            resolve();
          });
      });
    },
    /**
     * Search for assets by market ID
     * @param {Object} searchParams - Search parameters
     * @param {string} searchParams.tenantId - Tenant identifier
     * @param {string} searchParams.marketId - Market identifier
     * @param {string} searchParams.sectionId - Section identifier
     * @param {string} searchParams.textSearch - Text search query
     * @param {number} searchParams.pageNumber - Page number for pagination
     * @param {number} searchParams.pageCount - Number of items per page
     * @param {boolean} searchParams.with3D - Include 3D assets in results
     * @param {number} searchParams.sortMethod - Sort method identifier
     * @param {string} searchParams.token - Authentication token
     */
    GetSearchResultsByMarketId(
      { commit, getters, rootGetters, state, rootState },
      searchParams
    ) {
      commit("SetSearchedSection", searchParams.sectionName);
      commit("SetSearchInProgress", true);
      return new Promise((resolve) => {
        const requestTenantId =
          rootState.authentication.user?.profile?.selected_tenant ||
          rootState.workspace?.currentTenantId ||
          null;

        const stateMarketCount = Array.isArray(state.markets)
          ? state.markets.length
          : 0;
        const hasMultipleMarkets = stateMarketCount > 1;

        const endpoint = hasMultipleMarkets
          ? "asset/cross-market-search"
          : "asset/search";

        const payload = hasMultipleMarkets
          ? searchParams
          : { ...searchParams, marketId: undefined };

        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi + endpoint,
            payload,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            const activeTenantId =
              rootState.authentication.user?.profile?.selected_tenant ||
              rootState.workspace?.currentTenantId ||
              null;

            if (String(activeTenantId || "") !== String(requestTenantId || "")) {
              console.warn("[GetSearchResultsByMarketId] dropping stale cross-tenant response", {
                requestTenantId,
                activeTenantId,
              });
              commit("SetSearchInProgress", false);
              resolve();
              return;
            }

            const hasMarketAccess = rootGetters["authentication/hasMarketAccess"];
            const effectiveMarketId = getters.effectiveMarketId;
            const payload = response && response.data ? response.data : {};
            const sourceResults = Array.isArray(payload.results)
              ? payload.results
              : [];

            const filteredResults =
              hasMarketAccess && effectiveMarketId
                ? sourceResults.filter((r) => {
                    if (!r || !r.marketId) return true;
                    return (
                      String(r.marketId).toLowerCase() ===
                      String(effectiveMarketId).toLowerCase()
                    );
                  })
                : sourceResults;

            commit("SetSearchInProgress", false);
            commit("SetSearchResults", {
              ...payload,
              results: filteredResults,
            });
            resolve();
          });
      });
    },

    //Category
    GetCategoryHeadersBySection({ commit }, sectionid) {
      return new Promise((resolve) => {
        axios
          .get(
            CONFIG.platformEndpoints.assetxpapi +
              "category/getheadersbysection/" +
              sectionid,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            commit("SetCategoryHeaders", response.data);
            resolve();
          });
      });
    },
    UpsertCategoryInSection({ commit }, category) {
      return new Promise((resolve) => {
        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi + "category/upsertinsection",
            category,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            commit("SetActiveSection", response.data);
            resolve();
          });
      });
    },
    RemoveCategoryInSection({ commit }, categoryid) {
      return new Promise((resolve) => {
        axios
          .get(
            CONFIG.platformEndpoints.assetxpapi +
              "category/removeinsection/" +
              categoryid,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            commit("SetActiveSection", response.data);
            resolve();
          });
      });
    },
    RemoveCategoryAndAssets({ commit }, categoryid) {
      return new Promise((resolve) => {
        axios
          .get(
            CONFIG.platformEndpoints.assetxpapi +
              "category/removecategoryandassets/" +
              categoryid,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve();
          });
      });
    },

    //Section
    GetSectionHeaders({ commit }) {
      return new Promise((resolve) => {
        axios
          .get(
            CONFIG.platformEndpoints.assetxpapi + "section/getheaders",
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            commit("SetSectionHeaders", response.data);
            resolve();
          });
      });
    },
    UpdateSection({ commit }, editedSection) {
      return new Promise((resolve) => {
        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi + "section/update",
            editedSection,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            commit("SetActiveSection", response.data);
            resolve();
          });
      });
    },
    UpdateSectionCatalogue({ commit }, catalogue) {
      return new Promise((resolve) => {
        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi + "section/updatecatalogue",
            catalogue,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve();
          });
      });
    },
    GetCategoriesForSection({ commit, getters }, sectionName) {
      return new Promise((resolve) => {
        const marketId = getters.effectiveMarketId;
        const endpoint = marketId
          ? `section/getcategories/${sectionName}/${marketId}`
          : `section/getcategories/${sectionName}`;

        axios
          .get(
            CONFIG.platformEndpoints.assetxpapi + endpoint,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve(response.data);
          });
      });
    },
    GetSectionData({ commit, getters }, sectionName) {
      return new Promise((resolve) => {
        const marketId = getters.effectiveMarketId;
        const endpoint = marketId
          ? `section/getsectiondata/${sectionName}/${marketId}`
          : `section/getsectiondata/${sectionName}`;

        axios
          .get(
            CONFIG.platformEndpoints.assetxpapi + endpoint,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve(response.data);
          });
      });
    },
    GetSection({ commit, getters }, sectionName) {
      return new Promise((resolve) => {
        const marketId = getters.effectiveMarketId;
        const endpoint = marketId
          ? `section/get/${sectionName}/${marketId}`
          : `section/get/${sectionName}`;

        axios
          .get(
            CONFIG.platformEndpoints.assetxpapi + endpoint,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            commit("SetActiveSection", response.data);
            resolve();
          });
      });
    },
    ExportAssetsBySection({ commit, getters }, sectionId) {
      return new Promise((resolve) => {
        const marketId = getters.effectiveMarketId;
        const endpoint = marketId
          ? `section/getsectionassetdata/${sectionId}/${marketId}`
          : `section/getsectionassetdata/${sectionId}`;

        axios({
          url: CONFIG.platformEndpoints.assetxpapi + endpoint,
          method: "GET",
          config: {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: GetBearerToken(),
            },
          },
          responseType: "blob",
          headers: { Authorization: GetBearerToken() },
        }).then((response) => {
          const blob = new Blob([response.data], { type: MIME_TYPES.xlsx });
          downloadBlob(blob, "Export.xlsx");
          resolve();
        });
      });
    },
    ExportAssetsAllSections({ commit }, exportRequest) {
      return new Promise((resolve) => {
        axios({
          url:
            CONFIG.platformEndpoints.assetxpapi +
            "section/getassetsfromallsections",
          params: { p_jobid: exportRequest.jobid },
          method: "GET",
          config: {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: GetBearerToken(),
            },
          },
          responseType: "blob",
          headers: { Authorization: GetBearerToken() },
        }).then((response) => {
          const blob = new Blob([response.data], { type: MIME_TYPES.xls });
          downloadBlob(blob, "AssetExport.xls");
          resolve();
        });
      });
    },
    PDFExportAssetsBySection({ commit }, exportRequest) {
      return new Promise((resolve) => {
        axios({
          url:
            CONFIG.platformEndpoints.assetxpapi +
            "section/getsectionassetdataPDF",
          params: { p_sectionid: exportRequest.sectionid },
          method: "GET",
          config: {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: GetBearerToken(),
            },
          },
          responseType: "blob",
          headers: { Authorization: GetBearerToken() },
        }).then((response) => {
          const blob = new Blob([response.data], { type: MIME_TYPES.pdf });
          downloadBlob(blob, "AssetExport.pdf");
          resolve();
        });
      });
    },
    PDFExportAllSections({ commit }, exportRequest) {
      return new Promise((resolve) => {
        axios({
          url:
            CONFIG.platformEndpoints.assetxpapi +
            "section/getassetsfromallsectionsPDF",
          method: "GET",
          config: {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: GetBearerToken(),
            },
          },
          responseType: "blob",
          headers: { Authorization: GetBearerToken() },
        }).then((response) => {
          const blob = new Blob([response.data], { type: MIME_TYPES.pdf });
          downloadBlob(blob, "AssetExport.pdf");
          resolve();
        });
      });
    },
    GetSectionById({ commit }, sectionid) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            CONFIG.platformEndpoints.assetxpapi +
              "section/getbyid/" +
              sectionid,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            commit("SetActiveSection", response.data);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    ResetSelectedSection({ commit }) {
      commit("SetActiveSection", null);
    },
    ClearSectionAndSearchStateForWorkspaceSwitch({ commit }) {
      commit("SetActiveSection", null);
      commit("SetActiveAsset", null);
      commit("SetSearchData", {});
      commit("ClearSearch");
      commit("SetSearchedSection", "");
      commit("ClearAllSectionSearchFromCache");
      commit("SetMarkets", []);
      commit("SetMarketsTenantId", null);
      commit("SetSelectedMarket", null);
    },
    CreateSection({ commit }, sectionToCreate) {
      return new Promise((resolve) => {
        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi + "section/create",
            sectionToCreate,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve(response.data);
          });
      });
    },
    RemoveSection({ commit }, sectionidToRemove) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            CONFIG.platformEndpoints.assetxpapi +
              "section/remove/" +
              sectionidToRemove,
            GetAuthorisationHeaderGroup()
          )
          .then(() => {
            commit("SetActiveSection", null);
            resolve();
          })
          .catch((error) => {
            console.error("Failed to remove section:", error);
            reject(error);
          });
      });
    },
    GetAllAttributes({ commit, getters, rootGetters }, sectionid) {
      return new Promise((resolve, reject) => {
        const marketId = getters.effectiveMarketId;
        const useClonableAssetsEndpoint =
          rootGetters["authentication/hasMarketAccess"] && marketId;

        const endpoint = useClonableAssetsEndpoint
          ? `api/ClonableAssets/get-attributes-by-market-id/${marketId}`
          : marketId
            ? `attribute/getall/${marketId}`
            : "attribute/getall";

        axios
          .get(
            CONFIG.platformEndpoints.assetxpapi + endpoint,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            if (useClonableAssetsEndpoint) {
              console.error(
                "Error fetching attributes by market from ClonableAssets:",
                error
              );
            }
            reject(error);
          });
      });
    },
    GetSectionAttributes({ commit }, sectionid) {
      return new Promise((resolve) => {
        axios
          .get(
            CONFIG.platformEndpoints.assetxpapi +
              "section/getattributes/" +
              sectionid,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve(response);
          });
      });
    },
    GetSectionListings({ commit }, sectionid) {
      return new Promise((resolve) => {
        axios
          .get(
            CONFIG.platformEndpoints.assetxpapi +
              "section/getsectionlistings/" +
              sectionid,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve(response);
          });
      });
    },
    GetSectionAssetTemplate({ commit }, sectionid) {
      return new Promise((resolve) => {
        axios
          .get(
            CONFIG.platformEndpoints.assetxpapi +
              "section/getsectionassettemplate/" +
              sectionid,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve(response);
          });
      });
    },

    async CreateWidget({ commit }, formData) {
      return new Promise((resolve) => {
        axios({
          method: "post",
          data: formData,
          url:
            CONFIG.platformEndpoints.assetxpapi +
            "section/addWidgetToTemplate/",
          config: {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: GetBearerToken(),
            },
          },
          responseType: "json",
          headers: { Authorization: GetBearerToken() },
        }).then((response) => {
          resolve(response);
        });
      });
    },
    async DeleteWidgetFromTemplate({ commit }, widgetId) {
      return new Promise((resolve) => {
        axios
          .get(
            CONFIG.platformEndpoints.assetxpapi +
              "section/removeWidgetFromTemplate/" +
              widgetId,
            GetAuthorisationHeaderGroup()
          )
          .then(() => {
            resolve();
          });
      });
    },
    async UpdateWidget({ commit }, formData) {
      return new Promise((resolve) => {
        axios({
          method: "post",
          data: formData,
          url: CONFIG.platformEndpoints.assetxpapi + "section/updateWidget/",
          config: {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: GetBearerToken(),
            },
          },
          responseType: "json",
          headers: { Authorization: GetBearerToken() },
        }).then((response) => {
          resolve(response);
        });
      });
    },
    async OrderWidgets({ commit }, widgets) {
      return new Promise((resolve) => {
        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi + "section/orderwidgets",
            widgets,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve(response.data);
          });
      });
    },

    //Asset
    GetAsset({ commit, getters }, assetDetailid) {
      return new Promise((resolve, reject) => {
        const marketId = getters.effectiveMarketId;
        const marketQuery = marketId
          ? `?marketId=${encodeURIComponent(marketId)}`
          : "";
        axios
          .get(
            CONFIG.platformEndpoints.assetxpapi +
              "assetcontext/get/" +
              assetDetailid +
              marketQuery,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            commit("SetActiveAsset", response.data);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    ResetSelectedAsset({ commit }) {
      commit("SetActiveAsset", null);
      commit("SetAssetProfileData", []);
      commit("SetAssetProfileDataAssetId", null);
    },
    GetProfiles({ commit, state }) {
      return new Promise((resolve, reject) => {
        if (Array.isArray(state.profiles) && state.profiles.length > 0) {
          resolve(state.profiles);
          return;
        }

        axios
          .get(
            CONFIG.platformEndpoints.assetxpapi + "profile/getall",
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            const profiles = Array.isArray(response.data) ? response.data : [];
            commit("SetProfiles", profiles);
            resolve(profiles);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    GetAssetProfileData({ commit, state }, assetId) {
      return new Promise((resolve, reject) => {
        if (!assetId) {
          commit("SetAssetProfileData", []);
          commit("SetAssetProfileDataAssetId", null);
          resolve([]);
          return;
        }

        if (state.assetProfileDataAssetId === assetId) {
          resolve(state.assetProfileData);
          return;
        }

        commit("SetAssetProfileData", []);
        commit("SetAssetProfileDataAssetId", assetId);

        axios
          .get(
            CONFIG.platformEndpoints.assetxpapi +
              "assetprofiledata/getbyasset/" +
              assetId,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            const assetProfileData = Array.isArray(response.data)
              ? response.data
              : [];
            commit("SetAssetProfileData", assetProfileData);
            resolve(assetProfileData);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    AddProfileIdentifier({ commit, state }, payload) {
      // payload: { assetId, profileId, identifierValue }
      return new Promise((resolve, reject) => {
        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi + "assetprofiledata/add",
            payload,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            // Update the profile record from the response if it exists
            if (response.data) {
              commit("UpsertAssetProfileDataRecord", response.data);
              resolve(response.data);
            } else {
              // If no response body (204), reload profile data to stay in sync
              const currentAssetId = state.assetProfileDataAssetId;
              if (currentAssetId) {
                axios
                  .get(
                    CONFIG.platformEndpoints.assetxpapi +
                      "assetprofiledata/getbyasset/" +
                      currentAssetId,
                    GetAuthorisationHeaderGroup()
                  )
                  .then((reloadResponse) => {
                    const assetProfileData = Array.isArray(reloadResponse.data)
                      ? reloadResponse.data
                      : [];
                    commit("SetAssetProfileData", assetProfileData);
                    resolve(assetProfileData);
                  })
                  .catch(() => {
                    // If reload fails, still resolve as the add likely succeeded
                    resolve(null);
                  });
              } else {
                resolve(null);
              }
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    RemoveProfileIdentifier({ commit, state }, payload) {
      // payload: { assetId, profileId, identifierValue }
      return new Promise((resolve, reject) => {
        axios
          .delete(
            CONFIG.platformEndpoints.assetxpapi + "assetprofiledata/remove",
            {
              data: payload,
              ...GetAuthorisationHeaderGroup()
            }
          )
          .then(() => {
            // Remove identifier from state
            commit("RemoveProfileIdentifier", {
              profileId: payload.profileId,
              normalizedValue: payload.identifierValue.trim().toLowerCase()
            });
            // Reload profile data to ensure sync with server
            const currentAssetId = state.assetProfileDataAssetId;
            if (currentAssetId) {
              axios
                .get(
                  CONFIG.platformEndpoints.assetxpapi +
                    "assetprofiledata/getbyasset/" +
                    currentAssetId,
                  GetAuthorisationHeaderGroup()
                )
                .then((reloadResponse) => {
                  const assetProfileData = Array.isArray(reloadResponse.data)
                    ? reloadResponse.data
                    : [];
                  commit("SetAssetProfileData", assetProfileData);
                  resolve();
                })
                .catch(() => {
                  // If reload fails, still resolve
                  resolve();
                });
            } else {
              resolve();
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    SetDefaultProfileIdentifier({ commit, state }, payload) {
      // payload: { assetId, profileId, identifierValue }
      return new Promise((resolve, reject) => {
        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi + "assetprofiledata/setdefault",
            payload,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            // Always reload profile data after setting default to avoid stale response payloads.
            const currentAssetId = payload.assetId || state.assetProfileDataAssetId;
            if (!currentAssetId) {
              if (response.data) {
                commit("UpsertAssetProfileDataRecord", response.data);
                resolve(response.data);
              } else {
                resolve(null);
              }

              return;
            }

            axios
              .get(
                CONFIG.platformEndpoints.assetxpapi +
                  "assetprofiledata/getbyasset/" +
                  currentAssetId,
                GetAuthorisationHeaderGroup()
              )
              .then((reloadResponse) => {
                const assetProfileData = Array.isArray(reloadResponse.data)
                  ? reloadResponse.data
                  : [];
                commit("SetAssetProfileData", assetProfileData);
                commit("SetAssetProfileDataAssetId", currentAssetId);
                resolve(assetProfileData);
              })
              .catch(() => {
                // Fallback to direct upsert if refresh fails.
                if (response.data) {
                  commit("UpsertAssetProfileDataRecord", response.data);
                  resolve(response.data);
                  return;
                }

                resolve(null);
              });
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    ImportProfileValues({ commit }, { marketId, file }) {
      // payload: { marketId: string, file: File }
      return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append("file", file);
        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi +
              `assetprofiledata/import/${encodeURIComponent(marketId)}`,
            formData,
            {
              headers: {
                Authorization: GetBearerToken(),
                "content-type": "multipart/form-data",
              },
            }
          )
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    ExportProfileValues({ state }, { marketId, profileId, profileName }) {
      // payload: { marketId: string, profileId?: string, profileName?: string }
      return new Promise((resolve, reject) => {
        let endpoint = `assetprofiledata/export?marketId=${encodeURIComponent(marketId)}`;
        if (profileId) {
          endpoint += `&profileId=${encodeURIComponent(profileId)}`;
        }
        axios({
          url: CONFIG.platformEndpoints.assetxpapi + endpoint,
          method: "GET",
          responseType: "blob",
          headers: { Authorization: GetBearerToken() },
        })
          .then((response) => {
            const sanitizeFilenamePart = (value) => (value || '')
              .trim()
              .replace(/\s+/g, '_')
              .replace(/[^A-Za-z0-9_-]/g, '');
            const marketName = (state.markets || []).find((market) => market?.id === marketId)?.name || marketId;
            const safeMarketName = sanitizeFilenamePart(marketName) || marketId;
            const safeProfileName = sanitizeFilenamePart(profileName) || 'AllProfiles';
            const timestamp = new Date().toISOString().slice(0, 16).replace(/[-:]/g, '').replace('T', '_');
            const filename = `ProfileValues_${safeMarketName}_${safeProfileName}_${timestamp}.xlsx`;
            const blob = new Blob([response.data], {
              type: MIME_TYPES.xlsx,
            });
            downloadBlob(blob, filename);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    RemoveAsset({ commit }, assetDetailidToRemove) {
      return new Promise((resolve) => {
        axios
          .get(
            CONFIG.platformEndpoints.assetxpapi +
              "asset/remove/" +
              assetDetailidToRemove,
            GetAuthorisationHeaderGroup()
          )
          .then(() => {
            commit("SetActiveAsset", null);
            resolve();
          });
      });
    },
    RemoveMultipleAssets({ commit }, assetRemovalModel) {
      return new Promise((resolve) => {
        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi + "asset/removemultiple",
            assetRemovalModel,
            GetAuthorisationHeaderGroup()
          )
          .then(() => {
            resolve();
          });
      });
    },
    async CreateAsset({ commit }, newAsset) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi + "asset/create",
            newAsset,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            commit("SetActiveAsset", response.data);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    UpdateAsset({ commit }, assetUpdateInputModel) {
      return new Promise((resolve) => {
        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi + "asset/update",
            assetUpdateInputModel,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            commit("SetActiveAsset", response.data);
            resolve();
          });
      });
    },
    UpdateResourceMeta({ commit }, resourceMetaUpdateModel) {
      return new Promise((resolve) => {
        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi + "asset/updateResourceMeta",
            resourceMetaUpdateModel,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve();
          });
      });
    },
    GetAllAssetResources({ commit }, assetDetailid) {
      commit("SetDownloadingResources");

      return new Promise((resolve) => {
        axios({
          url:
            CONFIG.platformEndpoints.assetxpapi +
            "asset/downloadResources/" +
            assetDetailid,
          method: "GET",
          responseType: "blob",
          headers: { Authorization: GetBearerToken() },
          config: { headers: { Authorization: GetBearerToken() } },
        }).then((response) => {
          const blob = new Blob([response.data], { type: MIME_TYPES.zip });
          downloadBlob(blob, "resources.zip");
          commit("SetDownloadingResources");
          resolve();
        });
      });
    },
    GetCurrentAssetResource({ commit }, params) {
      var aDid = params.hasOwnProperty("assetDetailid")
        ? params.assetDetailid
        : null;
      var resourceid = params.hasOwnProperty("resourceid")
        ? params.resourceid
        : null;
      var filename = params.hasOwnProperty("fileName")
        ? params.fileName
        : "file.jpg";

      commit("SetDownloadingResources");

      return new Promise((resolve) => {
        axios({
          url:
            CONFIG.platformEndpoints.assetxpapi +
            "asset/downloadcurrentresource/" +
            aDid +
            "/" +
            resourceid,
          method: "GET",
          responseType: "blob",
          headers: { Authorization: GetBearerToken() },
          config: { headers: { Authorization: GetBearerToken() } },
        }).then((response) => {
          const blob = new Blob([response.data], { type: MIME_TYPES.binary });
          downloadBlob(blob, filename);
          commit("SetDownloadingResources");
          resolve();
        });
      });
    },
    RemoveAssetResource({ commit }, params) {
      var aDid = params.hasOwnProperty("assetDetailid")
        ? params.assetDetailid
        : null;
      var resourceid = params.hasOwnProperty("resourceid")
        ? params.resourceid
        : null;

      return new Promise((resolve) => {
        axios
          .get(
            CONFIG.platformEndpoints.assetxpapi +
              "asset/removeresource/" +
              aDid +
              "/" +
              resourceid,
            GetAuthorisationHeaderGroup()
          )
          .then(() => {
            resolve();
          });
      });
    },
    ToggleDefaultAssetResource({ commit }, params) {
      var aDid = params.hasOwnProperty("assetDetailid")
        ? params.assetDetailid
        : null;
      var resourceid = params.hasOwnProperty("resourceid")
        ? params.resourceid
        : null;

      return new Promise((resolve) => {
        axios
          .get(
            CONFIG.platformEndpoints.assetxpapi +
              "asset/toggledefaultresource/" +
              aDid +
              "/" +
              resourceid,
            GetAuthorisationHeaderGroup()
          )
          .then(() => {
            resolve();
          });
      });
    },
    ImportAssetsFromImages({ commit }, formData) {
      return new Promise((resolve) => {
        axios({
          method: "post",
          data: formData,
          url:
            CONFIG.platformEndpoints.assetxpapi +
            "asset/importassetsfromimages/",
          config: {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: GetBearerToken(),
            },
          },
          responseType: "json",
          headers: { Authorization: GetBearerToken() },
        }).then((response) => {
          resolve(response);
        });
      });
    },
    UpdateAssetsWithImages({ commit }, formData) {
      return new Promise((resolve) => {
        axios({
          method: "post",
          data: formData,
          url:
            CONFIG.platformEndpoints.assetxpapi +
            "asset/updateassetswithimages/",
          config: {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: GetBearerToken(),
            },
          },
          responseType: "json",
          headers: { Authorization: GetBearerToken() },
        }).then((response) => {
          resolve(response);
        });
      });
    },
    UpdateResourceData({ commit, rootState }, payload) {
      return new Promise((resolve) => {
        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi + "asset/updateresourcedata",
            payload,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve();
          });
      });
    },
    async UploadResourceIndividual({ commit, rootState }, payload) {
      let formData = new window.FormData();
      formData.append("file", payload.file.file);
      formData.append("replaceResources", payload.replaceResources);
      formData.append(
        "createNewAssetIfNotFound",
        payload.createNewAssetIfNotFound
      );
      formData.append("targetSpecificCategory", payload.targetSpecificCategory);
      formData.append("sectionid", payload.sectionid);
      formData.append("categoryid", payload.categoryid);
      formData.append("autoCropEnabled", payload.autoCropEnabled);
      formData.append(
        "removeExistingResourcesOfTheSameType",
        payload.removeExistingResourcesOfTheSameType
      );
      formData.append(
        "addOnlyIfNoExistingType",
        payload.addOnlyIfNoExistingType
      );
      formData.append(
        "seperateUnderscoresIntoTags",
        payload.seperateUnderscoresIntoTags
      );

      console.log("Doing an upload internal");
      console.log(formData);

      const config = {
        onUploadProgress: function(progressEvent) {
          var percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          console.log(percentCompleted);
        },
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: GetBearerToken(),
        },
      };

      let url =
        CONFIG.platformEndpoints.assetxpapi + "section/uploadFileIncremental";

      if (rootState.authentication.claims.canUploadLargeFiles) {
        url =
          CONFIG.platformEndpoints.assetxpapi +
          "section/uploadFileIncrementalLarge";
      }

      console.log("Sending to url ", url);

      for (let i = 0; i < 3; i++) {
        let res = await axios({
          method: "post",
          data: formData,
          url: url,
          config: config,
          responseType: "text",
          headers: { Authorization: GetBearerToken() },
        });

        if (res.status == 200) {
          throw res.data;
        }
      }
    },
    UploadResources({ commit, rootState }, formData) {
      let targetUrl =
        CONFIG.platformEndpoints.assetxpapi + "asset/updateassetresources/";

      if (rootState.authentication.claims.canUploadLargeFiles) {
        targetUrl =
          CONFIG.platformEndpoints.assetxpapi +
          "asset/updateassetresourceslarge/";
      }

      return new Promise((resolve) => {
        axios({
          method: "post",
          data: formData,
          url: targetUrl,
          config: {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: GetBearerToken(),
            },
          },
          responseType: "json",
          headers: { Authorization: GetBearerToken() },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            resolve(error.request);
          });
      });
    },
    UploadResourceSequence({ commit }, formData) {
      return new Promise((resolve) => {
        axios({
          method: "post",
          data: formData,
          url:
            CONFIG.platformEndpoints.assetxpapi +
            "asset/updateassetresourceassequence/",
          config: {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: GetBearerToken(),
            },
          },
          responseType: "json",
          headers: { Authorization: GetBearerToken() },
        }).then((response) => {
          resolve(response);
        });
      });
    },

    //Attributes
    GetAttributeManagement({ commit, getters }) {
      return new Promise((resolve) => {
        const marketId = getters.effectiveMarketId;
        const endpoint = marketId
          ? `attribute/getAttributeManagement/${marketId}`
          : "attribute/getAttributeManagement";

        axios
          .get(
            CONFIG.platformEndpoints.assetxpapi + endpoint,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve(response);
          });
      });
    },
    GetAttributeDetails({ commit }, attributeId) {
      return new Promise((resolve) => {
        axios
          .get(
            CONFIG.platformEndpoints.assetxpapi +
              "attribute/getAttributeDetails/" +
              attributeId,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve(response);
          });
      });
    },
    GetAttributeClassifications({ commit }, attributeIds) {
      const ids = Array.isArray(attributeIds) ? attributeIds.filter((id) => !!id) : [];
      if (ids.length === 0) {
        return Promise.resolve({ data: [] });
      }

      return new Promise((resolve) => {
        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi + "api/attributeclassifications/batch",
            { attributeIds: ids },
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve(response);
          })
          .catch(() => {
            resolve({ data: [] });
          });
      });
    },
    GetAttributeClassificationsByMarket({ getters }, marketId) {
      const resolvedMarketId = marketId || getters.effectiveMarketId;
      if (!resolvedMarketId) {
        return Promise.resolve({ data: [] });
      }

      return new Promise((resolve) => {
        axios
          .get(
            CONFIG.platformEndpoints.assetxpapi +
              "api/attributeclassifications/market/" +
              encodeURIComponent(resolvedMarketId),
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve(response);
          })
          .catch(() => {
            resolve({ data: [] });
          });
      });
    },
    SetAttributeClassification({ commit }, payload) {
      const attributeId = payload ? payload.attributeId : null;
      const classification = payload ? payload.classification : null;

      return new Promise((resolve, reject) => {
        if (!attributeId && attributeId !== 0) {
          resolve(null);
          return;
        }

        axios
          .put(
            CONFIG.platformEndpoints.assetxpapi +
              "api/attributeclassifications/" +
              attributeId,
            { classification },
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    DeleteAttributeClassification({ commit }, attributeId) {
      return new Promise((resolve, reject) => {
        if (!attributeId && attributeId !== 0) {
          resolve(null);
          return;
        }

        axios
          .delete(
            CONFIG.platformEndpoints.assetxpapi +
              "api/attributeclassifications/" +
              attributeId,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    GetProfileAttributeOverrides({ commit }, payload) {
      const profileId = payload ? payload.profileId : null;
      const marketId = payload ? payload.marketId : null;

      if (!profileId || !marketId) {
        return Promise.resolve({ data: [] });
      }

      return new Promise((resolve, reject) => {
        axios
          .get(
            CONFIG.platformEndpoints.assetxpapi +
              `profileattributedata/get?profileId=${encodeURIComponent(
                profileId
              )}&marketId=${encodeURIComponent(marketId)}`,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    SetProfileAttributeNameOverride({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi +
              "profileattributedata/set-attribute-name",
            payload,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    RemoveProfileAttributeNameOverride({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .delete(
            CONFIG.platformEndpoints.assetxpapi +
              "profileattributedata/remove-attribute-name",
            {
              data: payload,
              ...GetAuthorisationHeaderGroup(),
            }
          )
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    SetProfileAttributeValueNameOverride({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi +
              "profileattributedata/set-value-name",
            payload,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    RemoveProfileAttributeValueNameOverride({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .delete(
            CONFIG.platformEndpoints.assetxpapi +
              "profileattributedata/remove-value-name",
            {
              data: payload,
              ...GetAuthorisationHeaderGroup(),
            }
          )
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async CreateAttribute({ commit, getters }, newAttribute) {
      return new Promise((resolve) => {
        const marketId = getters.effectiveMarketId;
        const endpoint = marketId
          ? `attribute/create/${marketId}`
          : "attribute/create";

        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi + endpoint,
            newAttribute,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve(response);
          });
      });
    },
    async RenameAttribute({ commit }, updatedAttribute) {
      return new Promise((resolve) => {
        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi + "attribute/changename",
            updatedAttribute,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve(response);
          });
      });
    },
    async RemoveAssetAttribute({ commit }, attributeId) {
      return new Promise((resolve) => {
        axios
          .get(
            CONFIG.platformEndpoints.assetxpapi +
              "attribute/remove/" +
              attributeId,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve();
          });
      });
    },
    async CreateUpdateAttributeBindingGroup({ commit }, bindingGroup) {
      return new Promise((resolve) => {
        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi +
              "attribute/createorupdatebindinggroup",
            bindingGroup,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve(response);
          });
      });
    },
    async RemoveAttributeBindingGroup({ commit }, groupId) {
      return new Promise((resolve) => {
        axios
          .get(
            CONFIG.platformEndpoints.assetxpapi +
              "attribute/removebindinggroup/" +
              groupId,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve();
          });
      });
    },
    async RunAttributeBindingGroup({ commit }, groupId) {
      return new Promise((resolve) => {
        axios
          .get(
            CONFIG.platformEndpoints.assetxpapi +
              "attribute/runbindinggroup/" +
              groupId,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve();
          });
      });
    },
    async CreateAttributeBindingCondition({ commit }, bindingCondition) {
      return new Promise((resolve) => {
        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi +
              "attribute/createbindingcondition",
            bindingCondition,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve(response);
          });
      });
    },
    async RemoveAttributeBindingCondition({ commit }, conditionId) {
      return new Promise((resolve) => {
        axios
          .get(
            CONFIG.platformEndpoints.assetxpapi +
              "attribute/removebindingcondition/" +
              conditionId,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve();
          });
      });
    },
    async OrderAttributes({ commit }, attributes) {
      return new Promise((resolve) => {
        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi + "attribute/orderattributes",
            attributes,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve(response.data);
          });
      });
    },
    async OrderAttributeValues({ commit }, attribute) {
      return new Promise((resolve) => {
        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi +
              "attribute/orderattributevalues",
            attribute,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve(response.data);
          });
      });
    },

    /**
     * Get attributes for cloning an asset without market restrictions
     * @param {Object} params - Request parameters
     * @param {string} params.assetId - ID of the asset
     * @param {string} params.sectionId - ID of the section
     * @returns {Promise} Promise that resolves with the attributes array
     */
    GetCloneAttributes({ commit }, { assetId, sectionId }) {
      return new Promise((resolve, reject) => {
        const requestBody = {
          assetId: assetId,
          sectionId: sectionId,
        };

        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi +
              "api/ClonableAssets/get-attributes-without-market-id",
            requestBody,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            console.error("Error fetching clone attributes:", error);
            reject(error);
          });
      });
    },

    /**
     * Clone an asset to a target market
     * @param {Object} cloneData - Clone request data
     * @param {string} cloneData.sourceAssetId - ID of the asset to clone
     * @param {string} cloneData.targetMarketId - ID of the target market
     * @param {string} cloneData.userId - ID of the user performing the clone
     * @param {string[]} cloneData.selectedAttributeIds - Array of attribute IDs to include
     * @param {string} cloneData.clonedAssetName - Name for the cloned asset
     * @param {string} cloneData.clonedAssetDescription - Description for the cloned asset
     * @param {string} cloneData.clonedAssetId - ID for the cloned asset
     * @returns {Promise} Promise that resolves with the cloned asset ID
     */
    CloneAssetToMarket({ commit }, cloneData) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            CONFIG.platformEndpoints.assetxpapi +
              "api/ClonableAssets/clone-to-market",
            cloneData,
            GetAuthorisationHeaderGroup()
          )
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            console.error("Error cloning asset:", error);
            reject(error);
          });
      });
    },
  },
  /* eslint-enable no-unused-vars */
  getters: {
    hasClonableSection: (state) => {
      const currentSection = state.section;
      const clonableSectionIds = state.clonableSectionIds;

      if (!currentSection || !currentSection.id || !clonableSectionIds) {
        return false;
      }

      return clonableSectionIds.includes(currentSection.id);
    },
    effectiveMarketId: (state, getters, rootState, rootGetters) => {
      const markets = Array.isArray(state.markets) ? state.markets : [];
      const marketIdsFromState = markets.map((m) => (m && m.id ? m.id : null)).filter(Boolean);

      const validMarketIds = marketIdsFromState;

      // No resolved market list yet.
      if (validMarketIds.length === 0) {
        // During startup/switch races, prefer the persisted selection so a page
        // refresh doesn't briefly fall back to the default market (matches the
        // preference order used once the market list has resolved, below).
        if (state.selectedMarketId) {
          return state.selectedMarketId;
        }
        const hasMarketAccess = rootGetters["authentication/hasMarketAccess"];
        if (hasMarketAccess) {
          const defaultMarketId = rootGetters["authentication/defaultMarketId"];
          return defaultMarketId || null;
        }
        return null;
      }

      // If a market is explicitly selected and valid for current workspace/user, use it.
      if (state.selectedMarketId && validMarketIds.includes(state.selectedMarketId)) {
        return state.selectedMarketId;
      }

      // Otherwise use default market if valid.
      const hasMarketAccess = rootGetters["authentication/hasMarketAccess"];
      if (hasMarketAccess) {
        const defaultMarketId = rootGetters["authentication/defaultMarketId"];
        if (defaultMarketId && validMarketIds.includes(defaultMarketId)) {
          return defaultMarketId;
        }
      }

      // Final fallback is first valid market id.
      return validMarketIds[0] || null;
    },
  },
};
